import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import {Outlet} from 'react-router-dom'
import Footer from './components/Footer'
import Header from './components/Header'

export default function MainLayout() {

  return (
    <Container id="MainContainer" maxWidth={false} sx={{margin: 0, padding: '0 !important'}}>
      <Box sx={{margin: 0, padding: 0}}>
        <Header/>
        <Container sx={{minHeight: 'calc(100vh - 155px)'}} maxWidth="lg">
          <main>
            <Outlet/>
          </main>
        </Container>
        <Footer/>
      </Box>
    </Container>
  )
}
